export default {
  uiSize: 375,
  equipmentEnd: "pc",
};
